import Button from './elements/Button';
import React, { useContext, useState } from 'react';
import Location from './elements/Location';
import { AppView } from './RootStep';
import { SelectedAddress, MapIFrameContext } from '../App';
import { BuildingInfo, MapIframe, MapMessageType, SaveMessage } from '../services/MapIframe';
import { Product, ProductCategory } from './ProductsSelection';
import FactsTable from './elements/FactsTable';
import TextButton from './elements/TextButton';
import { CalculatorData } from '../services/CalculatorData';

interface ProductsStepProps {
    appView: AppView,
    setAppView: React.Dispatch<AppView>,
    address: SelectedAddress | null,
    buildingInfo: BuildingInfo | null
    selectedProduct: Product | null
}

function ProductsStep(props: ProductsStepProps) {

    const [, setCartId] = useState<String>()
    const mapContext = useContext(MapIFrameContext);

    const handleConfirmClick = () => {

        let cartId = MapIframe.generateCartId();

        saveCartInMap(mapContext, cartId);
        setCartId(cartId)

        props.setAppView(AppView.FINISH);

    };

    const handleBackClick = () => {
        props.setAppView(props.appView - 1);
    };

    const solarRows = CalculatorData.getProductTableRows(props.buildingInfo, props.selectedProduct);
    const costTableRows = CalculatorData.getCostTableRows(props.buildingInfo, props.selectedProduct);

    const productTable = props.selectedProduct?.category === ProductCategory.SOLAR ?
        <FactsTable title="Solar" rows={solarRows}></FactsTable>
        : <></>

    return <div className="py-8 mx-6">
        <div className="mx-auto text-center">
            <h2 className="text-base font-semibold leading-7 text-cyan-600">THOR DEMO</h2>
            <p className="mt-2 text-2xl font-bold tracking-tight text-gray-900">Choose products</p>
            <div className="mt-2">
                <Location label={props.address?.label} small={true}></Location>
            </div>
            <h3 className={'mt-12 mb-4 text-xl text-gray-900 text-left'}>{props.selectedProduct?.name}</h3>
            {productTable}
            <div className={'mt-4'}>
                <FactsTable title="Total" rows={costTableRows}></FactsTable>
            </div>
        </div>
        <div className="mt-6">
            <Button full={true} disabled={!props.selectedProduct} onClick={handleConfirmClick} text="Submit request"></Button>
            <div className="mt-6">
                <TextButton text="&larr; Back to address selection" onClick={handleBackClick}></TextButton>
            </div>
        </div>
    </div>;
}

function saveCartInMap(mapContext: React.RefObject<HTMLIFrameElement> | null, cartId: string) {
    if (mapContext) {
        MapIframe.post(mapContext, {
            cartId: cartId,
            type: MapMessageType.SAVE,
        } as SaveMessage);
    }
}

export default ProductsStep;